/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getProcedureEpisodes } from 'app/entities/procedure-episode/procedure-episode.reducer';
import { ProcedureOutcome } from 'app/shared/model/enumerations/procedure-outcome.model';
import { ProcedureStatus } from 'app/shared/model/enumerations/procedure-status.model';
import { ProcedureStatusReason } from 'app/shared/model/enumerations/procedure-status-reason.model';
import { createEntity, getEntity, reset, updateEntity } from './patient-procedure-episode.reducer';

export const PatientProcedureEpisodeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const procedureEpisodes = useAppSelector(state => state.procedureEpisode.entities);
  const patientProcedureEpisodeEntity = useAppSelector(state => state.patientProcedureEpisode.entity);
  const loading = useAppSelector(state => state.patientProcedureEpisode.loading);
  const updating = useAppSelector(state => state.patientProcedureEpisode.updating);
  const updateSuccess = useAppSelector(state => state.patientProcedureEpisode.updateSuccess);
  const procedureOutcomeValues = Object.keys(ProcedureOutcome);
  const procedureStatusValues = Object.keys(ProcedureStatus);
  const procedureStatusReasonValues = Object.keys(ProcedureStatusReason);

  const handleClose = () => {
    navigate(`/patient-procedure-episode${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getProcedureEpisodes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.plannedStart !== undefined && typeof values.plannedStart !== 'number') {
      values.plannedStart = Number(values.plannedStart);
    }
    if (values.plannedEnd !== undefined && typeof values.plannedEnd !== 'number') {
      values.plannedEnd = Number(values.plannedEnd);
    }
    if (values.actualStart !== undefined && typeof values.actualStart !== 'number') {
      values.actualStart = Number(values.actualStart);
    }
    if (values.actualEnd !== undefined && typeof values.actualEnd !== 'number') {
      values.actualEnd = Number(values.actualEnd);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...patientProcedureEpisodeEntity,
      ...values,
      procedure: patientProcedures.find(it => it.id.toString() === values.procedure?.toString()),
      metaEpisode: procedureEpisodes.find(it => it.id.toString() === values.metaEpisode?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          outcome: 'SCT_385669000',
          status: 'PLANNED',
          statusReason: 'SCT_183932001',
          ...patientProcedureEpisodeEntity,
          procedure: patientProcedureEpisodeEntity?.procedure?.id,
          metaEpisode: patientProcedureEpisodeEntity?.metaEpisode?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientProcedureEpisode.home.createOrEditLabel" data-cy="PatientProcedureEpisodeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.home.createOrEditLabel">
              Create or edit a PatientProcedureEpisode
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-procedure-episode-id"
                  label={translate('tinyMedicRestApp.patientProcedureEpisode.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.plannedStart')}
                id="patient-procedure-episode-plannedStart"
                name="plannedStart"
                data-cy="plannedStart"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.plannedEnd')}
                id="patient-procedure-episode-plannedEnd"
                name="plannedEnd"
                data-cy="plannedEnd"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.actualStart')}
                id="patient-procedure-episode-actualStart"
                name="actualStart"
                data-cy="actualStart"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.actualEnd')}
                id="patient-procedure-episode-actualEnd"
                name="actualEnd"
                data-cy="actualEnd"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.outcome')}
                id="patient-procedure-episode-outcome"
                name="outcome"
                data-cy="outcome"
                type="select"
              >
                {procedureOutcomeValues.map(procedureOutcome => (
                  <option value={procedureOutcome} key={procedureOutcome}>
                    {translate(`tinyMedicRestApp.ProcedureOutcome.${procedureOutcome}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.notes')}
                id="patient-procedure-episode-notes"
                name="notes"
                data-cy="notes"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.status')}
                id="patient-procedure-episode-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {procedureStatusValues.map(procedureStatus => (
                  <option value={procedureStatus} key={procedureStatus}>
                    {translate(`tinyMedicRestApp.ProcedureStatus.${procedureStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.statusReason')}
                id="patient-procedure-episode-statusReason"
                name="statusReason"
                data-cy="statusReason"
                type="select"
              >
                {procedureStatusReasonValues.map(procedureStatusReason => (
                  <option value={procedureStatusReason} key={procedureStatusReason}>
                    {translate(`tinyMedicRestApp.ProcedureStatusReason.${procedureStatusReason}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.active')}
                id="patient-procedure-episode-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.cursor')}
                id="patient-procedure-episode-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.lastUpdated')}
                id="patient-procedure-episode-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.microSec')}
                id="patient-procedure-episode-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedureEpisode.timestampEntry')}
                id="patient-procedure-episode-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="patient-procedure-episode-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.patientProcedureEpisode.procedure')}
                type="select"
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-episode-metaEpisode"
                name="metaEpisode"
                data-cy="metaEpisode"
                label={translate('tinyMedicRestApp.patientProcedureEpisode.metaEpisode')}
                type="select"
              >
                <option value="" key="0" />
                {procedureEpisodes
                  ? procedureEpisodes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-procedure-episode" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientProcedureEpisodeUpdate;
